import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HydraCollection } from '../hydra/hydra-collection';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommitteeApiService extends ApiService {
  readonly resourcePath = 'joint_committees'; 

  list(filters: Record<string, string> = {}): Observable<HydraCollection<any>> {
    return this.restList<any>(filters);
  }
}
